import React, { memo } from "react";
import { Col, Row } from "reactstrap";

interface IProps {
  label: string;
}

const QuestionTitleComponent = ({ label }: IProps) => (
  <Row>
    <Col className="question-title" title={label} xs={12}>
      {label}
    </Col>
  </Row>
);
QuestionTitleComponent.displayName = "QuestionTitle";
export const QuestionTitle = memo(QuestionTitleComponent);
